import { ISheetProps, Sheet } from './Sheet'
import { IMenuSheetOptionProps } from './MenuSheetOptions'
import React, { FC } from 'react'
import signOut from '@amzn/meridian-tokens/base/icon/sign-out'
import Column from '@amzn/meridian/column'
import Button from '@amzn/meridian/button'
import Text from '@amzn/meridian/text'
import Icon from '@amzn/meridian/icon'
import Row from '@amzn/meridian/row'

const menuOptionSpace = '300'
export interface IMenuSheetProps extends ISheetProps {
    /**
     * Optional title to provide to show on the menu sheet
     */
    title?: string
    /**
     * The children should be MenuSheetOption components.
     *
     * @type {React.ReactElement}
     */
    children: React.ReactElement<IMenuSheetOptionProps> | Array<React.ReactElement<IMenuSheetOptionProps>>
}

export const MenuSheet: FC<IMenuSheetProps> = (props: IMenuSheetProps) => {
    // Set default props.
    return (
        <Sheet id={props.id} open={props.open} enableCloseButton={true} setSheetOpen={props.setSheetOpen} primaryText={props.title ?? ''}>
            <Column alignmentHorizontal="left" spacing={menuOptionSpace}>
                {props.children}
            </Column>
        </Sheet>
    )
}
